
import { Target, TrendingUp, Zap } from 'lucide-react';

const FeaturesSectionV2 = () => {
  const features = [
    {
      icon: Target,
      title: 'Simple Focus',
      description: 'One commitment at a time. No overwhelm, just clear daily actions that build momentum.'
    },
    {
      icon: TrendingUp,
      title: 'Visual Progress',
      description: 'See your streaks grow in real-time. Watch your consistency become truly unstoppable.'
    },
    {
      icon: Zap,
      title: 'Build Streaks',
      description: 'Turn daily actions into lasting habits with gentle accountability and celebration.'
    }
  ];

  return (
    <section className="container max-w-6xl mx-auto px-4 py-24">
      <div className="text-center mb-16">
        <h2 className="text-5xl md:text-6xl font-black text-white mb-4 tracking-tight">
          Everything you need to
          <span className="block text-yellow-400">build lasting habits</span>
        </h2>
      </div>
      
      <div className="grid md:grid-cols-3 gap-8">
        {features.map((feature, index) => {
          const Icon = feature.icon;
          return (
            <div key={index} className="text-center group hover:transform hover:scale-105 transition-all duration-300">
              <div className="w-20 h-20 bg-white/15 backdrop-blur-sm rounded-3xl flex items-center justify-center mx-auto mb-8 group-hover:bg-white/25 transition-all duration-300 border border-white/10">
                <Icon className="w-10 h-10 text-yellow-400" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">{feature.title}</h3>
              <p className="text-white/80 leading-relaxed text-lg font-medium max-w-sm mx-auto">{feature.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default FeaturesSectionV2;
